<div class="popup-content">
  <h2>{{instruction.heading}}</h2>
  <ul>
    <li>{{instruction.device_requirement}}</li>
    @if(proctorSetting()?.enforce_camera) {
      <li>{{instruction.camera_instruction}}</li>
    }
    @if(proctorSetting()?.enforce_fullscreen) {
      <li>{{instruction.fullscreen_instruction}}</li>
    }
    <li>{{instruction.tabswitch_instruction_heading}}:
        <ul>
          <li>{{instruction.termination_warning}}</li>
          <li>{{instruction.tabswitch_instruction_second}}</li>
        </ul>
    </li>
    <li>{{instruction.save_answer}}</li>
    <li>{{instruction.test_time_window}}</li>
    <li>{{instruction.mark_review}}</li>
    <li>{{instruction.color_instruction}}
      <ul>
        <li><span class="color-indicator green"></span>{{instruction.answered_instruction}}</li>
        <li><span class="color-indicator red"></span>{{instruction.unanswered_instruction}}</li>
        <li><span class="color-indicator white"></span>{{instruction.unanswered_with_markreview_instruction}}</li>
      </ul>
    </li>
    <div class="confirm-block" *ngIf="checkBox()">
      <p-checkbox 
        [formControl]="confirm" 
        [value]="true"
        inputId="cnf"
        (onChange)="onClick()"
      />
      <label for="cnf">{{instruction.instruction_confirmation}}</label>
      <div class="continue-msg">
        @if (confirm.invalid && confirm.dirty) {
          <p>{{instruction.continue_message}}</p>
        }
      </div>
    </div>
    
  </ul>
</div>
